<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                {{TitleOne}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">{{TitleOne}}</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    Add New Record
                                </button>
                                <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg" (click)="
                                        download()">
                                    <i class="fe fe-download-cloud me-2"></i> {{'header.enrollment.titleList.DownloadReport' | translate}}
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu> -->
                            </div>
                        </div>
                    </div>
                    <!-- list of faculty start  -->

                    <!-- list of faculty end  -->
                    <!-- add of faculty start  -->
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ResultForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>Add New {{TitleOne}} Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                Add New {{TitleOne}} Information</p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>Update {{TitleOne}} Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                               Update Selected {{TitleOne}} Record
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>Delete {{TitleOne}} Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                Delete Selected {{TitleOne}} Record
                                            </p>
                                        </div>
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>List</mat-label>
                                                        <!-- <input matInput formControlName="" placeholder="Exam" > -->
                                                        <mat-select formControlName="EcId" #select23
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.ListDesc'" [array]="DataList"
                                                                (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredDataList"
                                                                [value]="item.EcId" (click)="getListData(item)">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['EcId'].touched && ResultForm.controls['EcId'].errors?.required">
                                                            This Field Is Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="listNo2" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="listNo3" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-3 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Valid</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Valid"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Changed</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Chng"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                (click)="list()">
                                                
                                                List
                                                </button>
                                            </div>
                                            <div class="col-sm-1">
                                                <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                >
                                                <!-- (click)="list()" -->
                                                Print
                                                </button>
                                            </div>
                                            <div class="col-sm-1" >
                                                <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                (click)="icrbtn()">
                                                <!--  -->
                                                ICR
                                                </button>
                                            </div>
                                            <div class="col-sm-1">
                                                <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                >
                                                <!-- (click)="list()" -->
                                                Exit
                                                </button>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix" *ngIf="Row1">
                                            
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Batch</mat-label>
                                                        <input matInput formControlName="Batch" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Batch'].touched && ResultForm.controls['Batch'].errors?.required">
                                                            This Field Is Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Batch'].touched && ResultForm.controls['Batch'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Exam</mat-label>
                                                        <input matInput formControlName="EmCode" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['EmCode'].touched && ResultForm.controls['EmCode'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>W/H</mat-label>
                                                        <mat-select formControlName="ExcpCode" #select23
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.CdDesc'" [array]="codeTypeList"
                                                                (filteredReturn)=" filteredCodeType =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredCodeType"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Set/Rem</mat-label>
                                                        <input matInput formControlName="SetRem" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['SetRem'].touched && ResultForm.controls['SetRem'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix" *ngIf="Row2">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Sub</mat-label>
                                                        <input matInput formControlName="Sub" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Sub'].touched && ResultForm.controls['Sub'].errors?.required">
                                                            This Field Is Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Sub'].touched && ResultForm.controls['Sub'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                       
                                                        <input matInput formControlName="Head" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Head'].touched && ResultForm.controls['Head'].errors?.required">
                                                            This Field Is Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Head'].touched && ResultForm.controls['Head'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            
                                            <div class="col-sm-2" *ngIf="Regno">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>RegnNo</mat-label>
                                                        <input matInput formControlName="RegnNo" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['RegnNo'].touched && ResultForm.controls['RegnNo'].errors?.required">
                                                            This Field Is Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['RegnNo'].touched && ResultForm.controls['RegnNo'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2" *ngIf="Rollno">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>RollNo</mat-label>
                                                        <input matInput formControlName="RollNo" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['RollNo'].touched && ResultForm.controls['RollNo'].errors?.required">
                                                            This Field Is Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['RollNo'].touched && ResultForm.controls['RollNo'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Marks</mat-label>
                                                        <input matInput formControlName="Marks" step="0.01" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-1" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        
                                                        <input matInput formControlName="MarksD" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Grade</mat-label>
                                                        <input matInput formControlName="Grade" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Grade'].touched && ResultForm.controls['Grade'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="row clearfix" *ngIf="Row3">
                                            <div class="col-sm-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Status</mat-label>
                                                        <input matInput formControlName="Status" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Status'].touched && ResultForm.controls['Status'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Comment</mat-label>
                                                        <input matInput formControlName="Comment" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Comment'].touched && ResultForm.controls['Comment'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Valid </mat-label>
                                                        <input matInput formControlName="Valid" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label></mat-label>
                                                        <input matInput formControlName="Mesg" placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ResultForm.controls['Mesg'].touched && ResultForm.controls['Mesg'].errors?.pattern">
                                                            Enter Valid Data
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="col-sm-12">
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="submitButton"
                                                (click)="submit()">Submit</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="editButton"
                                                (click)="update()">Update</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="deleteButton"
                                                (click)="delete()">Delete</button>
                                            <button type="button"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                (click)="addnewrecord('false')">Back</button>
                                        </div>
                                        <div class="table-responsive">
                                            <table id="datatable"
                                                class="table table-striped table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr>

                                                        <th class="f600">
                                                            Ec
                                                        </th>
                                                        <th class="f600">
                                                            Batch
                                                        </th>
                                                        <th class="f600" *ngIf="Rollno">
                                                            RollNo
                                                        </th>
                                                        <th class="f600" *ngIf="Regno">
                                                            RegnNo
                                                        </th>
                                                        <th class="f600">
                                                            Sub
                                                        </th>
                                                        <th class="f600">
                                                            Head
                                                        </th>
                                                        <th class="f600">
                                                            Marks
                                                        </th>
                                                        <th class="f600">
                                                            MarksD
                                                        </th>
                                                        <th class="f600">
                                                            Grade
                                                        </th>
                                                        <th class="f600">
                                                            St
                                                        </th>
                                                        <th class="f600">
                                                            WH
                                                        </th>
                                                        <th class="f600">
                                                            S-R
                                                        </th>
                                                        <th>
                                                            Comment
                                                        </th>
                                                        <th>
                                                            PrevMarks
                                                        </th>
                                                        <th>
                                                            PrevResult
                                                        </th>
                                                        <th>
                                                            NewForm
                                                        </th>
                                                        <th>
                                                            HigherExams
                                                        </th>
                                                        <th>
                                                            Changed
                                                        </th>
                                                        <th>
                                                            Valid
                                                        </th>
                                                        <th>
                                                            Message
                                                        </th>
                                                        <th>
                                                            Exam
                                                        </th>
                                                        <th width="10%" class="f600 text-center">
                                                            {{'header.enrollment.table.Action' | translate}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr *ngFor="let result of gridList;">
                                                        <!--  -->
                                                        <td>
                                                            {{result.EcId}}
                                                        </td>
                                                        <td>
                                                            {{result.Batch}}
                                                        </td>
                                                        <td *ngIf="Rollno">
                                                            {{result.RollNo}}
                                                        </td>
                                                        <td *ngIf="Regno">
                                                            {{result.RegnNo}}
                                                        </td>
                                                        <td>
                                                            {{result.Sub}}
                                                        </td>
                                                        <td>
                                                            {{result.Head}}
                                                        </td>
                                                        <td>
                                                            {{result.Marks}}
                                                        </td>
                                                        <td>
                                                            {{result.MarksD}}
                                                        </td>
                                                        <td>
                                                            {{result.Grade}}
                                                        </td>
                                                        <td>
                                                            {{result.Status}}
                                                        </td>
                                                        <td>
                                                            {{result.ExcpCode}}
                                                        </td>
                                                        <td>
                                                            {{result.SetRem}}
                                                        </td>
                                                        <td>
                                                            {{result.Comment}}
                                                        </td>
                                                        <td>
                                                            {{result.PrevMarks}}
                                                        </td>
                                                        <td>
                                                            {{result.PrevResult}}
                                                        </td>
                                                        <td>
                                                            {{result.NewForm}}
                                                        </td>
                                                        <td>
                                                            {{result.HigherExams}}
                                                        </td>
                                                        <td>
                                                            {{result.Chng}}
                                                        </td>
                                                        <td>
                                                            {{result.Valid}}
                                                        </td>
                                                        <td>
                                                            {{result.Mesg}}
                                                        </td>
                                                        <td>
                                                            {{result.EmCode}}
                                                        </td>
                                                        <td class="text-center">

                                                            <a class="btn-floating" title="Edit"
                                                                >
                                                                <!-- (click)="edit('true','faculty')" -->
                                                                <i class="fa fa-edit"></i>
                                                            </a>
                                                            <a class="btn-floating" title="Delete"
                                                                >
                                                                <!-- (click)="deletee('true','faculty')" -->
                                                                <i class="fas fa-trash"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>